export default "__VITE_ASSET__CXEsxriD__"